module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_3750_Active@1x-746f99e11e0932998f800ad3a16b817f.png";